<template>
  <v-row no-gutters>
    <v-col v-if="account" cols="12">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <!-- Level 1 -->
          <v-row justify="space-between" justify-sm="center">
            <v-col cols="12" xs="12" sm="12" class="text-left">
              <v-list-item>
                <!-- <v-list-item-avatar color="grey"></v-list-item-avatar> -->
                <v-list-item-content>
                  <v-list-item-title class="headline">{{account.name}}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ account.broker }}
                    {{ account.live ? "Live" : "Demo" }} #
                    {{ account.loginId }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-spacer />
                <v-list-item-action>
                  <v-btn color="primary" fab depressed @click="onClose(account)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-col>
          </v-row>
          <v-divider />

          <v-row no-gutters justify="space-between">
            <v-col cols="12" :md="3" :sm="6">
              <miniProfile :user="currentUser" />
            </v-col>

            <v-col cols="12" :md="2" :sm="6">
              <v-list>
                <v-list-item>As Traders: {{ asTraders.length }}</v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" :md="2" :sm="6">
              <v-list>
                <v-list-item>As Investors: {{ asInvestors.length }}</v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-divider />
          <v-card-actions>
            <v-btn v-if="isAuth(account.id)" color="primary" text class="mr-2" @click="onTerminal">
              <v-icon left>code</v-icon>Terminals
            </v-btn>

            <v-btn outlined color="primary" text class="mr-2" @click="onCommands">
              <v-icon left>history</v-icon>Commands
            </v-btn>

            <v-btn outlined color="primary" text class="mr-2" @click="onCopy">
              <v-icon left>filter_none</v-icon>Copy
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col v-if="active == 'copy'" cols="12" sm="12">
          <Subscribe :trader-account="account" />
        </v-col>
        <v-col v-else-if="active == 'terminal'" cols="12" sm="12">
          <EditorBar :trader-account-id="account.id" />
        </v-col>
        <v-col v-else cols="12" sm="12">
          <Commands :account-id="account.id" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { SUBSCRIPTION } from "@/store/actions.type";
import miniProfile from "@/components/users/miniProfile.vue";
import Subscribe from "@/components/subscriptions/Subscribe.vue";
import Commands from "@/components/commands/Table.vue";
import EditorBar from "@/components/terminals/EditorBar.vue";

export default {
  name: "Account",
  components: {
    miniProfile,
    Subscribe,
    EditorBar,
    Commands
  },
  props: {
    account: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      subscription: false,
      terminal: false,
      asTraders: [],
      asInvestors: [],
      active: "terminal"
    };
  },
  computed: {
    ...mapGetters(["accounts", "isAuthenticated", "currentUser"])
  },
  mounted() {
    this.getTraders(this.account);
    this.getInvestors(this.account);
  },
  methods: {
    getTraders(account) {
      this.$store.dispatch(SUBSCRIPTION.GET_TRADER, account.id).then(data => {
        this.asTraders = data;
      });
    },
    getInvestors(account) {
      this.$store.dispatch(SUBSCRIPTION.GET_INVESTOR, account.id).then(data => {
        this.asInvestors = data;
      });
    },
    onCopy() {
      // this.subscription = !this.subscription;
      this.active = "copy";
    },
    onTerminal() {
      // this.terminal = !this.terminal;
      this.active = "terminal";
    },
    onCommands() {
      this.active = "commands";
    },
    isAuth(userId) {
      return userId == this.currentUser.uid;
    },
    onClose(item) {
      this.$emit("onClose", item);
    }
  }
};
</script>

<style></style>
